import { BaseDto } from './base.dto';

export class BundleProductDto extends BaseDto {
  name?: string;
  printName?: string;
  bundleChecked?: boolean;
  price?: number;
}
